window.open_window = function(url) {
    if(window.android) {
        window.android.jnRequestOpenBrowser(url);
    }
    else {
        window.open(url, '_blank');
    }
};

window.jnRequestVerify = function () {
    if (window.android) {
        window.android.jnRequestVerify();
    }
};

window.njRegisterGCM = function (gcm) {
    ajaxCall('/app/android/register_gcm', $.param(JSON.parse(gcm)), function(json) {});
};

window.njUnregisterGCM = function (gcm) {
    ajaxCall('/app/android/unregister_gcm', $.param(JSON.parse(gcm)), function(json) {});
};

// inapp payment start
window.get_payload = function (id) {
    ajaxCall('/app/android/get_payload', 'id=' + id, function(json) {
        if (json.resultType === 'OK' || json.resultType === 'success') {
            jnRequestGoogleInappBillingPurchase(JSON.stringify(json.result));
        }
    });
};

// request
window.jnRequestGoogleInappBillingPurchase = function (payload) {
    // 'billing progress 2'
    if (window.android) {
        window.android.jnRequestGoogleInappBillingPurchase(payload);
    }
};

// response
window.njResponseGoogleInappBillingPurchase = function (paymentData) {
    openModalPaymentProcessing();
    ajaxCall('/app/android/payment', $.param(JSON.parse(paymentData)), function(json) {
        if (json.resultType === 'OK' || json.resultType === 'success') {
            jnRequestGoogleInappBillingConsume(json.result.developerPayload);
        } else {
            jnRequestGoogleInappBillingConsume(json.result.developerPayload);
        }
    });
};

/*
function app_purchase_result(json) {
    if(json.result_command != 'OK') {
        alert(json.result_command);
        return;
    }
    var payload = JSON.stringify(json.payload);
    $('#result_area').append("<div class='left mt10 '>구매 완료: " + payload + "</div>");
    jnRequestGoogleInappBillingConsume(payload);
}
*/

window.jnRequestGoogleInappBillingConsume = function (developerPayload) {
    if (window.android) {
        window.android.jnRequestGoogleInappBillingConsume(developerPayload);
    }
};

window.njResponseGoogleInappBillingConsume = function (purchaseJson, signature) {
    ajaxCall('/app/android/consume', 'purchaseJson=' + encodeURIComponent(purchaseJson) + '&signature=' + encodeURIComponent(signature), function(json) {
        resultGoogleInappBillingConsume(json);
    });
};

/*
function app_consume_result(json) {
    if(json.result_command != 'OK') {
        alert(json.result_command);
        return;
    }
    $('#result_area').append("<div class='left mt10 '>구매 완료</div>");
    $('#result_area').append("<div class='left mt10 '>" + JSON.stringify(json.verify_result) + "</div>");
    $('#point').html(number_format(json.point));
    toast('결제가 완료 되었습니다.', 4000);
}
*/
window.jnRequestSetBadge = function (count) {
    if (window.android) {
        window.android.jnRequestSetBadge(count.toString());
    }
};
window.njVerifyBillingServerSide = function () {
    // TODO: 'verifying billing 4'
};

window.gcm_result = function (json) {};
window.njDeliverWeb = function (data) {};
window.njViewResumed = function () {};
window.njResponseVerify = function () {};
window.jnDispatchEvent = function(event, params) {
    if (window.android) {
        window.android.jnDispatchEvent(event, params)
    }
};